import { render, staticRenderFns } from "./number-portrait-item.vue?vue&type=template&id=a8121124&scoped=true&"
import script from "./number-portrait-item.vue?vue&type=script&lang=js&"
export * from "./number-portrait-item.vue?vue&type=script&lang=js&"
import style0 from "./number-portrait-item.vue?vue&type=style&index=0&id=a8121124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8121124",
  null
  
)

export default component.exports